export default __webpack_public_path__ + "static/media/logo-leve.84181028.svg";